<template>
  <div class="scroll-x-items lg:flex-wrap">
    <div
      v-for="(item, index) in breadcrumb"
      :key="index"
      class="scroll-x-items__item"
    >
      <BaseLink
        v-bind="item.tagLinkProps"
        tag="a"
        :url="item.link.link_with_query_strings"
      >
        <span class="flex items-center">
          <span
            class="whitespace-nowrap inline-block text__sub--3 lg:text__body-2--regular"
            :class="[index !== breadcrumb.length - 1 ? 'text-label-text' : 'text-body-1']"
          >
            {{ item.anchor }}
          </span>
          <span v-if="!arrow && index !== breadcrumb.length - 1" class=" mx-1">/</span>
          <BaseIcon
            v-if="arrow && index !== breadcrumb.length - 1"
            color="text-body-1"
            name="keyboard_arrow_left"
          />
        </span>
      </BaseLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    },
    arrow: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss">
@mixin hide-scroll {
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scroll-x-items {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  @include hide-scroll;
}
</style>
